import { NodeSpec } from 'prosemirror-model';

import { getLinkTarget } from '@lyearn/core/utils/iframe';
import { BaseExtension } from '@lyearn/lygo-core';

import { MENTION_NODE_NAME, MENTION_TYPE_ATTR } from './const';
import plugins from './plugins';

export default class Mention extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        href: {
          default: null,
        },
        name: {
          default: null,
        },
        id: {
          default: null,
        },
        type: {
          default: null,
        },
      },
      group: 'inline',
      inline: true,
      atom: true,
      selectable: false,
      draggable: false,
      parseDOM: [
        {
          tag: 'a.mention',
          priority: 51,
          getAttrs: (dom: any) => {
            return {
              href: dom.getAttribute('href'),
              name: dom.getAttribute('data-mention-name'),
              id: dom.getAttribute('data-mention-id'),
              type: dom.getAttribute(MENTION_TYPE_ATTR),
            };
          },
        },
      ],
      toDOM: (node) => {
        let linkTarget = getLinkTarget(node.attrs.href, node.attrs.href ? '_blank' : undefined);
        return [
          'a',
          {
            target: linkTarget,
            'data-mention-id': node.attrs.id,
            'data-mention-name': node.attrs.name,
            href: node.attrs.href,
            [MENTION_TYPE_ATTR]: node.attrs.type,
            title: node.attrs.name,
            class: 'mention px-2',
            rel: 'noopener noreferrer nofollow',
            style: `color: #0065FF; background-color: #EFF6FF; border-radius: 4px; cursor:pointer; padding-top: 3px; padding-bottom: 3px;`,
          },
          '@' + node.attrs.name,
        ];
      },
    };
  }

  plugins = plugins;

  get name(): string {
    return MENTION_NODE_NAME;
  }
}
